<div class="row">
    <div class="col">

        <div class="errorAlertOpen" *ngIf="errorAlertOpen">

          <div class="alert alert-danger" *ngIf="showAuthFailErrMsg" role="alert">
            <span>The username and password entered do not match our records.<br /><br /></span>
            <span>Please check the information entered is correct and try again.</span>
          </div>

          <div class="alert alert-danger" *ngIf="showEmailErrMsg" role="alert">
            <span>We noticed that your email has not been verified.<br /><br /></span>
            <p>Please check and verify the email provided on registration and then proceed with sign in. Please navigate to
              <a [routerLink]="'/trouble-signing-in'">Trouble Signing In</a> if you have not received the verification email.
            </p>
            <span>If you believe you have received this message by mistake, please contact Customer Service at {{
              customerServicePhone }}.</span>
          </div>

          <div class="alert alert-danger" *ngIf="showAuthWarnErrMsg" role="alert">
            <span>The username and password entered do not match our records.<br /><br /></span>
            <p>Please try again. Also, your account will be frozen for 30 minutes after 3 tries. Please navigate to
              <a [routerLink]="'/trouble-signing-in'">Trouble Signing In</a> to continue.
            </p>
            <span>If you believe you have received this message by mistake, please contact Customer Service at {{
              customerServicePhone }}.</span>
          </div>

          <div class="alert alert-danger" *ngIf="showAccountLockedErrMsg" role="alert">
            <span>We noticed that your account has been locked. Please allow 30 minutes and then proceed to
              <a [routerLink]="'/trouble-signing-in'">Trouble Signing In</a>.<br /><br /></span>
            <span>If you believe you have received this message by mistake, please contact Customer Service at {{ customerServicePhone }}.</span>
          </div>

          <div class="alert alert-danger" *ngIf="showAccountRevokedErrMsg" role="alert">
            <span>We noticed that your account has been revoked.<br /><br /></span>
            <span>If you believe you have received this message by mistake, please contact Customer Service at {{ customerServicePhone }}.</span>
          </div>
        
          <div class="alert alert-danger" *ngIf="showNotFoundErrMsg" role="alert">
            <span>We encountered an issue completing your request.<br /><br /></span>
            <span>Please try again later or contact Customer Service at {{ customerServicePhone }}.</span>
          </div>

        </div>

        <div class="form-container p-3">
          <form id="sign-in-form" [formGroup]="signInForm" (ngSubmit)="submitSignInForm()">

            <div class="form-group form-label-group">
              <input formControlName="signInUsername" id="signInUsername" type="text" class="form-control" placeholder="Username">
              <label for="signInUsername">Username</label>
            </div>
            <div class="form-group form-label-group">
              <input formControlName="signInPassword" id="signInPassword" type="password" class="form-control" placeholder="Password">
              <label for="signInPassword">Password</label>
            </div>
            <div class="form-group pl-4">
              <input type="checkbox" formControlName="rememberMe" id="rememberMe" class="form-check-input">
              <p for="rememberMe" class="form-check-label">Remember me on this computer.</p>
            </div>

            <div class="row pb-3">
              <div class="col-12 d-flex">
                <span><a [routerLink]="'/trouble-signing-in'">Trouble signing in?</a></span>
                <button type="submit" id="submitSignInButton" [disabled]="signInForm.invalid"
                        class="btn rounded-pill bg-secondary text-white ml-auto px-4">
                  <span class="font-weight-bold">Sign In</span>
                </button>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 d-flex">
                <span class="ml-auto">Don't have an account?</span>
              </div>
              <div class="col-12 d-flex">
                <span class="ml-auto"><a [routerLink]="'/registration'">Create A New Account</a></span>
              </div>
            </div>

          </form>
        </div>

    </div>
</div>
